"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalMarkupOptions = void 0;
const GlobalMarkupOptions_1 = require("./GlobalMarkupOptions");
const useGlobalMarkupOptions_1 = __importDefault(require("./useGlobalMarkupOptions"));
exports.useGlobalMarkupOptions = useGlobalMarkupOptions_1.default;
exports.default = GlobalMarkupOptions_1.GlobalMarkupOptions;
//# sourceMappingURL=index.js.map